import { render, staticRenderFns } from "./SysData.vue?vue&type=template&id=8fff1cc0&scoped=true"
import script from "./SysData.vue?vue&type=script&lang=js"
export * from "./SysData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fff1cc0",
  null
  
)

export default component.exports